// extracted by mini-css-extract-plugin
export default {"container":"zPu0E","innerContainer":"yCihg","innerOverlay":"HIQn1","background":"IohNx","overlay":"dpmtO","picture":"tbPez","svg":"HPKtg","round":"HqvtN","nameLetter":"mD+fh"};